<template>
  <div class="main-bg">
    <b-row class="custom-row">
      <div class="logo">
        <a href="/">
          <img class="custom-logo" src="../../assets/income.svg" width="120" alt=""/>
        </a>
      </div>
      <b-col align-self="center" md="6" sm="12">
        <div class="custom-form float-right">
          <b-form v-on:submit.prevent="register">
            <div class="register-form">
              <h1 class="register-label">Register</h1>
              <b-alert show variant="warning" v-if="validationError.password.length || validationError.username.length">
                {{ validationError.username }}{{ validationError.password }}
              </b-alert>

              <b-input-group class="reg-input-field">
                <template #prepend>
                  <b-input-group-text class="show-password">
                    <img :src="getSrc('elements/emailIcon.svg')" alt=""/>
                  </b-input-group-text>
                </template>
                <b-form-input class="reg-input"
                              id="input-username"
                              v-model="authData.username"
                              type="email"
                              :state="validationUsernameState"
                              placeholder="your@example.com"
                              required
                              ref="usernameSection"
                ></b-form-input>
              </b-input-group>

              <b-input-group class="reg-input-field mt-3">
                <template #prepend>
                  <b-input-group-text class="show-password">
                    <img :src="getSrc('elements/passwordIcon.svg')" alt=""/>
                  </b-input-group-text>
                </template>
                <b-form-input
                    class="reg-input"
                    pill
                    id="input-password"
                    :type="openPasswordType?'text':'password'"
                    :state="validationPasswordState"
                    v-model="authData.password"
                    placeholder="create your password"
                    required
                    ref="passwordSection"
                ></b-form-input>
                <template #append>
                  <b-input-group-text class="show-password">
                    <img
                        :src="openPasswordType?getSrc('elements/showPassword.svg'):getSrc('elements/hidePassword.svg')"
                        alt=""
                        @click="openPasswordType=!openPasswordType"/>
                  </b-input-group-text>
                </template>
              </b-input-group>
              <b-form-checkbox
                  size="lg"
                  class="accept-field"
                  v-model="checkboxAccept"
                  name="checkboxAccept"
                  value="1"
                  unchecked-value="0"
                  ref="checkboxAcceptSection"
              >
                <span class="agree-text">
                  I agree to the <a href="https://getincome.com/useragreement">user agreement</a> and <a href="https://getincome.com/privacy">privacy policy</a>.
                </span>
              </b-form-checkbox>
              <b-button
                  class="signup-btn"
                  block
                  pill
                  variant="primary"
                  content-cols-sm
                  content-cols-lg="5"
                  @click="register"
              >Register
              </b-button>
              <b-button
                  class="custom-spacing custom-sn-reg"
                  block
                  pill
                  variant="outline-secondary"
                  @click="redirectTo('facebook')"
              >
                <img class="icon" :src="getSrc('media/facebookIcon.svg')" alt=""/>
                <span>Register with Facebook</span>
              </b-button>
              <b-button
                  class="custom-spacing input-icons custom-sn-reg"
                  block
                  pill
                  variant="outline-secondary"
                  @click="redirectTo('google-oauth2')">
                <img class="icon" :src="getSrc('media/googleIcon.svg')" alt=""/>
                <span>Register with Google</span>
              </b-button>
              <b-button
                  class="custom-spacing custom-sn-reg"
                  pill
                  block
                  variant="outline-secondary"
                  @click="redirectTo('apple')">
                <img class="icon" :src="getSrc('media/appleIcon.svg')" alt=""/>
                <span>Register with Apple</span>
              </b-button>
              <div class="already-ha">
                <span>Already have an account? - </span>
                <router-link to="/login">Log in</router-link>
              </div>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col
          md="6" sm="0"
          class="disable-sm right-col"
      >
        <right-column/>
      </b-col>
    </b-row>

    <!--Success modal info-->
    <b-modal ref="reg-modal" modal-class="reg-modal" size="lg" centered hide-footer>

      <template #modal-header="{ close }">
        <div class="w-100 modal-header-top">
          <div class="small-logo">
            <img src="../../assets/small_income_logo.svg" alt=""/>
          </div>
        </div>
        <b-button size="sm" variant="outline" @click="close()">X</b-button>
      </template>

      <div class="reg-container">
        <div class="reg-content">
          <h3>Verify your email</h3>
          <b-alert
              :show="dismissCountDown"
              dismissible
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged"
              variant="success"
          >Your new email sent successfully! Check again your mailbox.</b-alert>
          <div class="reg-text">
            <div>We have sent you an email to <strong>{{ this.authData.username }}</strong>.</div>
            <br/>
            <div>Please check your inbox now and press the confirmation link.</div>
            <br/>
            <div>If you have not received the verification mail, please check your <strong>"Spam"</strong> or <strong>"Bulk email"</strong> folder. You can also click the resend button below to have
              another email sent to you.
            </div>
          </div>
        </div>
      </div>
      <div class="reg-btn">
        <b-button @click="$router.push({ path: 'login'})">{{ this.$t('views.home.gotit') }}</b-button>
        <span class="resend-section">
       <b-button
           content-cols-sm
           content-cols-lg="5"
          @click="resendEmail"
        >
          Resend
        </b-button>

        </span>
      </div>
    </b-modal>
  </div>

</template>

<script>
import axios from 'axios'
import RightColumn from '../../components/auth/RightColumn'
import imageMixin from '@/mixins/image'

export default {
  components: {RightColumn},
  mixins: [imageMixin],
  data()
  {
    return {
      authData: {
        username: '',
        password: ''
      },
      checkboxAccept: '0',
      validationUsernameState: null,
      validationPasswordState: null,
      validationError: {
        username: '',
        password: ''
      },
      openPasswordType: false,
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  mounted()
  {
    if (localStorage.getItem('accessToken') !== null)
    {
      this.$router.push('/register-complete')
    }
  },
  methods: {
    redirectToLogin()
    {
      this.$router.push('/login')
    },
    redirectTo(provider)
    {
      if (this.checkboxAccept === '0')
      {
        this.blink(this.$refs.checkboxAcceptSection)
        return false
      }
      this.$auth.login({target: this.$route.query.to}, provider)
    },
    register()
    {
      if (this.authData.username.length === 0)
      {
        this.blink(this.$refs.usernameSection)
        return false
      }
      if (this.authData.password.length === 0)
      {
        this.blink(this.$refs.passwordSection)
        return false
      }
      if (this.checkboxAccept === '0')
      {
        this.blink(this.$refs.checkboxAcceptSection)
        return false
      }

      this.validationUsernameState = null
      this.validationPasswordState = null
      this.validationError = {
        username: '',
        password: ''
      }
      this.danger = false
      axios.post('auth0-register', this.authData)
          .then((response) =>
          {
            if (response.data.success === true)
            {
              this.$refs['reg-modal'].show()
            }
            else
            {
              this.validationError = response.data.error
              this.validationUsernameState = this.validationError.username.length === 0
              this.validationPasswordState = this.validationError.password.length === 0
            }
          })
    },
    resendEmail()
    {
      if (this.user_id === null || this.dismissCountDown > 0)
      {
        console.log('Please wait ' + this.dismissCountDown + 'sec. No spam please!')
        return false
      }

      axios.post('auth0-send-verification', {username: this.authData.username})
        .then((response) =>
        {
          if (response.data.success === true)
          {
            this.dismissCountDown = this.dismissSecs
          }
          else
          {
            this.validationError = response.data.error
            this.validationUsernameState = this.validationError.username.length === 0
            this.validationPasswordState = this.validationError.password.length === 0
          }
        })
    },
    blink(el)
    {
      el.focus()
      el.$el.classList.add('blink-error')
      setTimeout(() =>
      {
        el.$el.classList.remove('blink-error')
      }, 500)
    },
    closeModal: function ()
    {
      this.$refs['reg-modal'].hide()
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  }
}
</script>

<style scoped lang="scss">
.custom-logo {
  position: absolute;
  top: 2rem;
  left: 5rem;

  .disable-sm {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 575px) {
  .custom-logo {
    position: initial;
    margin-left: 1rem !important;
    margin-top: 1rem !important;
    margin-bottom: 2rem !important;
  }
  .disable-sm {
    display: none;
  }
}

.custom-spacing {
  margin-bottom: 10px !important;
}

.icon {
  position: relative;
  float: left;
  min-width: 26px;
  margin-top: 0;
  text-align: left;
}

.apple-color {
  fill: #6c757d;
}

.custom-spacing:hover:not([disabled]) .icon .apple-color {
  fill: white;
}

.custom-row {
  margin: 0;
}

.custom-form {
  margin-right: 5vw !important;
}

@media only screen and (min-width: 1250px) {
  .custom-form {
    min-width: 520px;
  }
}

.right-col {
  background-color: rgba(7, 29, 45, 1);
  padding: 0;
}

.main-bg {
  background-color: #F5FBFF;
}

.blink-error {
  color: red !important;
  border: 1px dotted red !important;
  border-radius: 5px;
}

.show-password {
  max-height: 72px;
  background: transparent;
  border: none;
}

.reg-input-field {
  height: 72px;
  background: #E2F3FE;
  border: none;
  border-radius: 15px;

  .reg-input {
    height: 72px;
    background: none;
    border: none;
    box-shadow: none;
    font-size: 20px;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill, {
    -webkit-box-shadow: none !important;
    background-image: none !important;
    background-color: transparent !important;
    color: #000000 !important;
    -webkit-text-fill-color: #000;
  }
}

.accept-field {
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
  border: 1px dotted #FFFFFF;

  .agree-text {
    margin-top: 3px;
    display: inline-block;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 1px;
  }
}

.signup-btn {
  background: #31A6FB;
  height: 72px;
  border: 15px;
  font-family: Open Sans, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  letter-spacing: 1px;
  color: #F5FBFF;
  margin-bottom: 15px;
}

.custom-sn-reg {
  height: 48px;
}

.custom-sn-reg:hover {
  color: #fff;
  background-color: #31A6FB;
  border-color: #31A6FB;
}

.register-label {
  font-family: Open Sans, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 87px;
  letter-spacing: 1px;
}

.already-ha {
  margin-top: 15px;
  font-family: Open Sans, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1px;
}

.register-form {
  max-width: 620px;
}

@media only screen and (min-width: 576px) and (max-width: 765px) {
  .register-form {
    min-width: 500px;
  }
  .logo {
    height: 110px;
    width: 100%;
  }
}

@media only screen and (min-width: 765px) and (max-height: 800px) {
  .logo {
    display: none;
  }
}

@media only screen and (min-width: 1765px) {
  .logo {
    display: block;
  }
}

.reg-modal {
  .modal-content {
    border-top: 15px solid #30A7FE;
    border-bottom: 15px solid #30A7FE;
    border-radius: 3.3rem;
  }

  .modal-header {
    border-bottom: 0;
  }

  h3 {
    margin-bottom: 45px;
    margin-top: 30px;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 41px;
    letter-spacing: 1px;
  }

  .reg-text {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 150%;
    color: rgba(7, 29, 45, 0.8);
    margin-bottom: 45px;
  }

  .reg-container {
    display: flex;
    flex-direction: column;

    .reg-content {
      order: 1;
    }

    .reg-icon {
      order: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -32px;
      margin-bottom: 32px;

      img {
        width: 45px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .small-logo {
      padding-left: 0 !important;
    }
  }
  @media only screen and (min-width: 768px) {
    .reg-container {
      flex-direction: row;

      .reg-content {
        order: 0;
        flex: 1 0 300px;
        margin-right: 32px;
      }

      .reg-icon {
        order: 1;
        flex: 0 0 240px;
        margin: 0;

        img {
          width: auto;
        }
      }
    }
  }

  .resend-section {
    float: right;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 141%;
    margin-right: 24px;
  }

  .small-logo {
    text-align: left;
    padding-left: 18px;
    opacity: 50%;
  }
}
</style>

<style lang="scss">
.reg-modal {
  .modal-content {
    border-top: 15px solid #30A7FE;
    border-bottom: 15px solid #30A7FE;
    border-radius: 3.3rem;
  }

  .modal-header {
    border-bottom: 0;
  }
}

@media only screen and (min-width: 768px) {
  .reg-modal {
    .modal-body {
      padding: 12px 12px 32px 54px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .reg-modal {
    .modal-dialog {
      max-width: 700px;
    }
  }
}

.reg-btn {
  width: 100%;
  display: block;

  button {
    background: #31A6FB;
    height: 63px;
    width: 170px;
    border-radius: 15px;
    border: 15px;
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 1px;
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 27px;
    color: #F5FBFF;
    @media (max-width: 420px) {
      width: auto;
      height: auto;
    }
  }
}

.reg-content {
  .text-larger {
    display: inline-block;
    margin-bottom: 5px;
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
